// Ref: http://jsforallof.us/2014/10/28/pagination-with-lodash/
angular.module('app').factory('PaginatorService', function () {
    // TODO: Store the paged items here
    let fac = {
        pagedItems: pagedItems,
        perPage: perPage
    };
    // Default to 300 as per Trace Details
    let per_page = 300;
    // Set the required number of items per page
    function perPage(numItems) {
        per_page = numItems;
    }
    // Pass in a list of items and a page number and return the page of items and 
    // the information required to configure Bottstrap pagination component
    function pagedItems(items, page) {
        let actualPerPage;
        let totalPages = Math.ceil(items.length / per_page);
        page = page || totalPages;
        let offset;
        if (page === 1) {
            // Ragged page 1
            offset = 0;
            actualPerPage = items.length % per_page || per_page;
        }
        else {
            // Full last page
            offset = items.length - (totalPages - page + 1) * per_page;
            actualPerPage = per_page;
        }
        let paginatedItems = _.drop(items, offset).slice(0, actualPerPage);
        let pagedItemsResponse = {
            page: page,
            per_page: per_page,
            total: items.length,
            total_pages: Math.ceil(items.length / per_page),
            data: paginatedItems
        };
        return pagedItemsResponse;
    }
    return fac;
});
